import { render, staticRenderFns } from "./QuickCalcIssue.vue?vue&type=template&id=36934504&scoped=true"
import script from "./QuickCalcIssue.vue?vue&type=script&lang=js"
export * from "./QuickCalcIssue.vue?vue&type=script&lang=js"
import style0 from "./QuickCalcIssue.vue?vue&type=style&index=0&id=36934504&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36934504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36934504')) {
      api.createRecord('36934504', component.options)
    } else {
      api.reload('36934504', component.options)
    }
    module.hot.accept("./QuickCalcIssue.vue?vue&type=template&id=36934504&scoped=true", function () {
      api.rerender('36934504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/QuickCalcIssue.vue"
export default component.exports